export const INTERNAL_URL_PROTOCOL = "puter:";

export const FAVICON_CACHE_TTL = 1000 * 60 * 60 * 24 * 7; // 1 week
